import { type ReactNode } from 'react'
import './AccessListSection.css'

interface AccessListItem {
  id: string
  icon: string | ReactNode
  primaryText: string
  secondaryText: string
  actionButton?: ReactNode
}

interface AccessListSectionProps {
  title: string
  items: AccessListItem[]
  emptyMessage?: string
  isLoading?: boolean
  className?: string
}

export function AccessListSection({ 
  title, 
  items, 
  emptyMessage = 'No items',
  isLoading = false,
  className = ''
}: AccessListSectionProps) {
  return (
    <div className={`access-list-section ${className}`}>
      <h4>{title}</h4>
      {isLoading ? (
        <div className="loading-items">Loading...</div>
      ) : items.length > 0 ? (
        <div className="access-list">
          {items.map((item) => (
            <div key={item.id} className="access-list-item">
              <div className="access-list-icon">
                {typeof item.icon === 'string' ? item.icon : item.icon}
              </div>
              <div className="access-list-details">
                <div className="access-list-primary">{item.primaryText}</div>
                <div className="access-list-secondary">{item.secondaryText}</div>
              </div>
              {item.actionButton}
            </div>
          ))}
        </div>
      ) : (
        <p className="no-items">{emptyMessage}</p>
      )}
    </div>
  )
}
